/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_4_AnswerInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_4_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First click inside the spreadsheet and make sure a dialog or text-editing control is not using the keyboard. Some shortcuts can also be reserved by the browser or operating system. Use the visible menu command when the shortcut is unavailable, and avoid testing destructive commands on your only copy.`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_4_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先点击电子表格内部，并确认焦点没有停留在对话框或文本编辑控件中。浏览器或操作系统也可能占用某些快捷键。快捷键不可用时使用可见菜单命令，不要在唯一副本上测试破坏性操作。`)
};

/**
* | output |
* | --- |
* | "First click inside the spreadsheet and make sure a dialog or text-editing control is not using the keyboard. Some shortcuts can also be reserved by the brows..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_4_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_4_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_4_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_4_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_4_answer(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_4_answer(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_4_answer as "gc.search_guides.gridcraft_online.sections.7.questions.4.answer" }